// Tag for graphql format
const gql = String.raw;

import { MakeMetricsFragment, WeightingFragment } from "@PayPlans/api/fragments/commons";

// Default Commissions fragments
const ProductFragment = gql`
	fragment Product on DefaultProductTier {
		input
		value
		product
	}
`;

const DefaultCommissionsTierFragment = gql`
	fragment DefaultTier on DefaultCommissionsTier {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		frontGross {
			...InputValue
		}
		backGross {
			...InputValue
		}
		frontProducts {
			...Product
		}
		backProducts {
			...Product
		}
	}
	${ProductFragment}
`;

const DefaultCommissionsContentFragment = gql`
	fragment DefaultCommissionsContent on DefaultCommissionsContent {
		new {
			...DefaultTier
		}
		preOwned {
			...DefaultTier
		}
	}
`;

const DefaultCommissionsFragment = gql`
	fragment DefaultCommissions on DefaultCommissions {
		content {
			...DefaultCommissionsContent
		}
		newAndPreOwnedRequired
		globalUnitCounts
		applyTiersRetroactively
		isGuaranteedDraw
	}
	${DefaultCommissionsContentFragment}
`;

// Mini Deals fragments
const MiniDealDefinitionFragment = gql`
	fragment MiniDealDefinition on MiniDealCommissionsDefinition {
		make
		model
		modelYears {
			...ModelYears
		}
		tiers {
			from {
				...InputValue
			}
			to {
				...InputValue
			}
			commission {
				...InputValue
			}
			addCommission {
				...InputValue
			}
		}
		applyGrossRetroactively
		capEnabled
		cap
	}
`;

const MiniDealFragment = gql`
	fragment MiniDeal on MiniDealCommissions {
		new {
			addons {
				...MiniDealDefinition
			}
			default {
				...MiniDealDefinition
			}
		}
		preOwned {
			addons {
				...MiniDealDefinition
			}
			default {
				...MiniDealDefinition
			}
		}
	}
	${MiniDealDefinitionFragment}
`;

// Model Based Commissions fragments
const ModelBasedCommissionsTierFragment = gql`
	fragment ModelBasedTier on ModelBasedCommissionsTier {
		make
		model
		modelYears {
			...ModelYears
		}
		tiers {
			...DefaultTier
		}
	}
`;

const ModelBasedCommissionsContentFragment = gql`
	fragment ModelBasedCommissions on ModelBasedCommissionsContent {
		new {
			...ModelBasedTier
		}
		preOwned {
			...ModelBasedTier
		}
	}
	${ModelBasedCommissionsTierFragment}
`;

const ModelBasedFragment = gql`
	fragment ModelBased on ModelBasedCommissions {
		content {
			...ModelBasedCommissions
		}
		globalUnitCounts
		applyTiersRetroactively
	}
	${ModelBasedCommissionsContentFragment}
`;

const AdjustmentTierFragment = gql`
	fragment AdjustmentTier on AdjustmentItemTiers {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		adjustment {
			...InputValue
		}
	}
`;

// Demo Allowance Commissions fragments
const AllowanceTierFragment = gql`
	fragment AllowanceTier on DemoAllowanceItemTiers {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		allowance {
			...InputValue
		}
	}
`;

const DemoAllowanceFragment = gql`
	fragment DemoAllowance on DemoAllowanceCommissions {
		commissions {
			...AllowanceTier
		}
		adjustments {
			...AdjustmentTier
		}
		subjectToReputation
	}
	${AllowanceTierFragment}
`;

// Packs Commissions fragments
const PackItemFragment = gql`
	fragment PackItem on PackCommissionsData {
		_id
		amount {
			...InputValue
		}
		soft
		title
	}
`;

const PacksFragment = gql`
	fragment Packs on PacksCommissions {
		new {
			...PackItem
		}
		preOwned {
			...PackItem
		}
	}
	${PackItemFragment}
`;

// Auto Alerts Commissions fragments
const AutoAlertsFragment = gql`
	fragment AutoAlerts on AutoAlertsCommissions {
		new {
			...InputValue
		}
		preOwned {
			...InputValue
		}
	}
`;

// Customer Satisfaction fragments
const SimpleMakeMetricsFragment = gql`
	fragment SimpleMakeMetrics on SimpleMakeMetrics {
		_id
		make
		oemReference
		version
		evaluateStoreMetrics
		individualMakeMetrics {
			...MakeMetrics
		}
		storeMakeMetrics {
			...MakeMetrics
		}
	}
	${MakeMetricsFragment}
`;

const CustomerSatisfactionFragment = gql`
	fragment CustomerSatisfaction on CustomerSatisfactionCommissions {
		makeMetrics {
			...SimpleMakeMetrics
		}
		weighting {
			...Weighting
		}
	}
	${SimpleMakeMetricsFragment}
	${WeightingFragment}
`;

export {
	DefaultCommissionsFragment,
	DefaultCommissionsTierFragment,
	MiniDealFragment,
	ModelBasedFragment,
	DemoAllowanceFragment,
	PacksFragment,
	AutoAlertsFragment,
	CustomerSatisfactionFragment,
	AdjustmentTierFragment,
};
